<i18n src="@/locales/modules/RoleTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="setDialogHide => handleCloseDialog(setDialogHide, isFormDirty)"
		class="custom-dialog"
		:title="$t(dataId ? 'UpdateRoles' : 'CreateRoles')"
		:visible.sync="isPopupActiveLocal"
	>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6">
				<!-- NAME -->
				<label for class="vs-input--label">{{ $t("RolesName") }} <span class="text-danger">*</span>:</label>
				<cbs-input :placeholder="$t('RolesName', '')" v-model="dataName" class="w-full" name="name" :data-vv-as="$t('RolesName')" data-vv-delay="100" v-validate="'required'" />
				<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first("name") }}</span>
			</div>

			<div class="py-6">
				<!-- Function -->
				<label for class="vs-input--label  px-6">{{ $t("Function") }}:</label>
				<vs-table :data="$store.state.rolesManagement.moduleRoles" class="list-roles">
					<template slot="thead" class="lg:table" v-for="(moduleRole, index) in $store.state.rolesManagement.moduleRoles">
						<template v-if="index === 0">
							<vs-th :key="index"></vs-th>
							<vs-th class="px-0" v-for="permission in moduleRole.permissions" :key="permission.name">
								<h6 class="break-word-initial">{{ permission.name }}</h6>
							</vs-th>
						</template>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data" class="bg-white">
							<vs-td class="font-bold break-word sm:font-normal sm:whitespace-no-wrap sm:pr-0 ">
								<div class="flex items-center">
									<vs-checkbox class="m-0 mr-2 inline-block flex items-center" v-model="checkAllPermisson[indextr]" />
									<span>{{ tr.group_name }}:</span>
								</div>
							</vs-td>
							<vs-td class="px-0" v-for="(permission, _index) in tr.permissions" :key="_index" :data-header="permission.name">
								<div class="text-right">
									<vs-checkbox class="flex items-center justify-end w-full" v-model="rolePermissions[permission.permission]" />
								</div>
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</div>
		</PerfectScrollbar>

		<div class="flex justify-center" slot="footer">
			<vs-button class="w-full sm:w-1/3 font-bold" @click="submitData">{{ $t("Actions.Submit") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters } from "vuex";
import { mapKeys } from "lodash";
export default {
	props: {
		isPopupActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	components: {
		vSelect
	},
	data() {
		return {
			dataId: null,
			dataName: "",
			description: "",

			initFormData: {},
			isFormDirty: false,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			rolePermissions: {},
			defaultPermissions: {},
			checkAllPermisson: {},
			moduleRoles: this.$store.state.rolesManagement.moduleRoles
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) {
				this.checkAllPermisson = {};
				return;
			}

			const { id, name, description, permissions } = this.data;
			if (!this.data.id) {
				this.initValues();
			} else {
				this.dataId = id;
				this.dataName = name;
				this.description = description;
			}
			const _defaultListPermission = permissions ? JSON.parse(permissions) : {};
			this.defaultPermissions = this.renderDefaultPermission(_defaultListPermission);

			this.isFormDirty = false;
			this.initFormData = {
				dataId: this.dataId,
				dataName: this.dataName,
				description: this.description,
				rolePermissions: Object.assign({}, this.rolePermissions)
			};
		},
		computedFormData: {
			handler: function(newVal) {
				this.isFormDirty = JSON.stringify(newVal) !== JSON.stringify(this.initFormData) && newVal.dataId === this.initFormData.dataId;
			},
			deep: true
		},
		checkAllPermisson: {
			handler: function(newVal) {
				mapKeys(newVal, (value, key) => {
					this.moduleRoles[key].permissions.map(item => {
						this.rolePermissions[item.permission] = value;
					});
				});
			},
			deep: true
		}
	},
	methods: {
		initValues() {
			if (this.data.id) return;
			this.dataId = null;
			this.dataName = "";
			this.description = "";
			this.$validator.reset();
		},
		handleCreateOrUpdateSuccess() {
			this.initValues();
			this.$emit("closePopup");
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: this.$t(`${this.dataId ? "UpdateRolesSuccessful" : "CreateRolesSuccessful"}`)
				}
			});
		},
		async handleCreateOrUpdateRole(dataObj) {
			try {
				this.$vs.loading();
				if (this.dataId) {
					await this.$store.dispatch("rolesManagement/updateRole", {
						...dataObj,
						id: this.dataId
					});
				} else {
					await this.$store.dispatch("rolesManagement/addRole", dataObj);
				}

				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData() {
			this.$validator.validateAll().then(result => {
				if (result) {
					const _rolePermissions = this.mapRolePermissionBooleanToString();
					const dataObj = {
						name: this.dataName,
						description: this.description,
						permissions: _rolePermissions
					};

					this.handleCreateOrUpdateRole(dataObj);
				}
			});
		},
		mapRolePermissionBooleanToString() {
			let _rolePermissions = {};
			this.$store.state.rolesManagement.moduleRoles.map(moduleRole => {
				moduleRole.permissions.map(item => {
					_rolePermissions[item.permission] = this.rolePermissions[item.permission] === true ? this.$constant.ROLES_VALUE.TRUE : this.$constant.ROLES_VALUE.FALSE;
				});
			});
			return JSON.stringify(_rolePermissions);
		},
		renderDefaultPermission(defaultListPermission) {
			this.$store.state.rolesManagement.moduleRoles.map(moduleRole => {
				moduleRole.permissions.map(item => {
					this.$set(this.rolePermissions, item.permission, defaultListPermission[item.permission] === this.$constant.ROLES_VALUE.TRUE ? true : false);
					// this.rolePermissions[item.permission] = defaultListPermission[item.permission] === this.$constant.ROLES_VALUE.TRUE ? true : false;
					this.initFormData.rolePermissions = Object.assign({}, this.rolePermissions);
				});
			});
		}
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			}
		},

		departmentChoices() {
			return (this.getFormattedFlattenTreeDepartments || []).map(department => ({
				value: department.id,
				text: department.name,
				depth: department.depth
			}));
		},
		...mapGetters({
			getFormattedFlattenTreeDepartments: "departmentManagement/getFormattedFlattenTreeDepartments"
		}),
		computedFormData() {
			return {
				dataId: this.dataId,
				dataName: this.dataName,
				description: this.description,
				rolePermissions: this.rolePermissions
			};
		}
	},
	created() {}
};
</script>

<style lang="scss" scoped>
::v-deep header {
	&.vs-popup--header {
		h3 {
			text-transform: uppercase;
		}
	}
}

.custom-nested-dialog ::v-deep .el-dialog {
	width: 680px;

	.list-roles {
		thead {
			line-height: 0;
		}

		th {
			padding: 0 10px !important;
		}

		.vs-table-text {
			font-size: 14px;
			font-weight: normal;
			justify-content: center;
			color: var(--color-black);
			text-transform: none;
			white-space: nowrap;
		}

		.con-slot-label {
			margin: 0;
		}

		.vs-checkbox--input {
			left: 0;
		}

		@media (min-width: 992px) {
			.vs-con-tbody {
				overflow-y: scroll !important;
				max-height: 35vh;
			}

			thead th {
				position: sticky;
				top: 0;
				background-color: #fff;
				z-index: 9;
				line-height: initial;
			}
		}
	}
}

.stack-table table td[data-header]:before {
	font-weight: normal;
}
.list-roles {
	.con-vs-checkbox {
		width: max-content;
	}
	.vs-con-table .vs-table--thead th {
		padding: 0 !important;
	}
}
</style>
